import React from "react"
import Button from "../../atoms/button/button"
import GenericModal from "../generic-modal/generic-modal"
import warnigImg from "../../../assets/images/signo-advertencia.png"
import "./warning-modal.scss"

const Wrapper = ({ noLayoutModal, children }) =>
  noLayoutModal ? (
    <div> {children} </div>
  ) : (
    <GenericModal> {children}</GenericModal>
  )

const WarningModal = ({
  title,
  description,
  noLayoutModal,
  primaryButtonText,
  primaryButtonOnClick,
  secondaryButtonText,
  secondaryButtonOnClick,
  children,
}) => {
  return (
    <Wrapper noLayoutModal={noLayoutModal}>
      <div className="f-warnig-modal">
        <img src={warnigImg} className="f-warnig-modal__img" />
        <h3 className="f-warnig-modal__title">{title}</h3>
        {children}
        <p className="f-warnig-modal__description">{description}</p>
        <div className="f-button-container">
          <Button
            title={secondaryButtonText}
            onClick={secondaryButtonOnClick}
            className="secondary-pink"
          />
          <Button
            title={primaryButtonText}
            onClick={primaryButtonOnClick}
            className="primary-pink"
          />
        </div>
      </div>
    </Wrapper>
  )
}

export default WarningModal
